import QuorumBusiness from '@/dominio/QuorumBusiness';
import RemoveDoneIcon from '@mui/icons-material/RemoveDone';
import { makeObservable, observable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroVotacaoComVotoDiferenteDeConfirmado extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Votação não realizada ou incompleta (com pelo menos 1 voto em situação diferente de "Confirmado")';
    }

    getIconeFiltroRapido() {
        return <RemoveDoneIcon />;
    }

    filtroRapido = {
        valor: true
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        return QuorumBusiness.existeParticipanteComVotoDiferenteDeConfirmado(registro);
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
